//Replace the "constants.js" with this in order to run on MainNet
const ASSET_ID =  42771692;
const ComplianceAddress = 'BSW4FRTCT2SXKVK6P53I57SEAOCCPD6TYAS77YUU725KCY6U7EM2LLJOEI'
export { ASSET_ID, ComplianceAddress};
